import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

const DividerCore = ({ orientation = 'horizontal', bold = false, className })=>{
    if (orientation === 'vertical') {
        return jsx("div", {
            "aria-orientation": "vertical",
            className: classNames('cb-divider', 'vertical', {
                bold
            }, className),
            "data-testid": "divider",
            role: "separator"
        });
    }
    return jsx("hr", {
        className: classNames('cb-divider', 'horizontal', {
            bold
        }, className),
        "data-testid": "divider"
    });
};
DividerCore.displayName = 'Divider.Core';

export { DividerCore };
//# sourceMappingURL=Divider.Core.es.js.map
